import { normalizeTime } from "@/libs/utils";
import { Label8 } from "../../typography/components/Label";
import { LabelMono5 } from "../../typography/components/LabelMono";
import { TokenProperty } from "../../ProductTabs/types";

export type PropertyProps = { tokenProperty: TokenProperty } & {
  className?: string;
};

const Property = ({ tokenProperty, ...props }: PropertyProps) => {
  const traitValue =
    tokenProperty.displayType === "date"
      ? normalizeTime(tokenProperty.value)
      : tokenProperty.value;

  return (
    <div className={props.className}>
      <dl>
        <LabelMono5 className="mb-1" as="dt">
          {tokenProperty.traitType}
        </LabelMono5>
        <Label8 className="text-white" as="dd">
          {traitValue}
        </Label8>
        {tokenProperty.prevalence && (
          <Label8 as="dd">{tokenProperty.prevalence} have this trait</Label8>
        )}
      </dl>
    </div>
  );
};

export default Property;
